import styled from '@emotion/styled';
import { ListItemButton } from '@mui/material';

const StyledListItemButton = styled(ListItemButton)({
  paddingLeft: 24,
  paddingRight: 24,
});

export default StyledListItemButton;
